import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from "react";
import * as Styled from "./node-alphabetical-id.style";
import { CanvasOverlay } from "./canvas-overlay";
import { useAppSelector, selectors } from "store";
import { NodeComponentType, OverlayData } from "store/types";
import { useGraphDataContext } from "providers/graph-panel";
import { AlphabeticalNodeType } from "hooks/graph-panel/graph";
import { useGetResultAlphabeticalId } from "hooks/use-result-alphabetical-id";
export var NodeAlphabeticalId = function (_a) {
    var node = _a.node, nodeCenterX = _a.nodeCenterX, nodeCenterY = _a.nodeCenterY;
    var getAnyAlphabeticalId = useGraphDataContext().getAlphabeticalId;
    var getResultAlphabeticalId = useGetResultAlphabeticalId();
    var selectedId = useAppSelector(selectors.selectSelectedId);
    var highlightedNodeIds = useAppSelector(selectors.selectHighlightedNodeIds);
    var isPerformanceOverlay = useAppSelector(selectors.selectOverlayData) ===
        OverlayData.PERFORMANCE_DATA;
    var isCentralizedSystem = useAppSelector(selectors.selectIsCentralizedSystem);
    /* Pointed out from outside the scene (e.g. by a finding that only says
     * "the cup"), the node shows its letter whatever the overlay, as long as
     * the letters match the shown results */
    var isHighlighted = highlightedNodeIds.includes(node.id);
    var getAlphabeticalId = isHighlighted
        ? getResultAlphabeticalId
        : getAnyAlphabeticalId;
    var alphabeticalIdCup = useMemo(function () {
        var isGripPosition = node.type === NodeComponentType.GRIP_POSITION;
        if (!isGripPosition)
            return;
        return getAlphabeticalId(node.id, AlphabeticalNodeType.CUP);
    }, [getAlphabeticalId, node.id, node.type]);
    var alphabeticalIdPump = useMemo(function () {
        var isCentralizedPump = node.type === NodeComponentType.CENTRALIZED_VACUUM_PUMP &&
            isCentralizedSystem;
        var isGripPositionInDecentralized = node.type === NodeComponentType.GRIP_POSITION && !isCentralizedSystem;
        if (!isCentralizedPump && !isGripPositionInDecentralized)
            return;
        return getAlphabeticalId(node.id, AlphabeticalNodeType.PUMP);
    }, [getAlphabeticalId, isCentralizedSystem, node.id, node.type]);
    var overlayOffset = isCentralizedSystem ? 0 : 30;
    /* We only want to render if:
     * The node is highlighted (e.g. the user hovering a row in the component
     * data list or a finding), and then only on the highlighted nodes. Or else:
     * Show component data is enabled.
     * If the node has an alphabeticalId (Only cups and pumps)
     * If no node is selected, so the labels do not hide the selected node. */
    var isShown = highlightedNodeIds.length > 0
        ? isHighlighted
        : isPerformanceOverlay && !selectedId;
    if (!isShown)
        return null;
    return (_jsxs(_Fragment, { children: [alphabeticalIdCup && (_jsx(CanvasOverlay, { x: nodeCenterX, y: nodeCenterY, children: _jsx(Styled.NodeAlphabeticalId, { children: alphabeticalIdCup }) })), alphabeticalIdPump && (_jsx(CanvasOverlay, { x: nodeCenterX - overlayOffset, y: nodeCenterY - overlayOffset, children: _jsx(Styled.NodeAlphabeticalId, { children: alphabeticalIdPump }) }))] }));
};
